import type { HelpFile } from '../../types/help'
import { ClusterNodesTestIds } from '../../../testids/ClusterNodesTestIds'

export const clusterNodesHelp: HelpFile = {
  docPage: '/docs/admin/cluster',
  texts: {
    [ClusterNodesTestIds.clusterNodesCard]:
      'Aktive Knoten im Anwendungscluster — Gesundheitsstatus und Lastverteilung.',
    [ClusterNodesTestIds.colActions]: null,
    [ClusterNodesTestIds.colHostname]: null,
    [ClusterNodesTestIds.colIpAddress]: null,
    [ClusterNodesTestIds.colLastHeartbeat]:
      'Letzter empfangener Heartbeat dieses Knotens — veraltete Heartbeats deuten auf einen Ausfall hin.',
    [ClusterNodesTestIds.colNodeId]: null,
    [ClusterNodesTestIds.colRegistered]: null,
    [ClusterNodesTestIds.colStatus]: null,
    [ClusterNodesTestIds.masterNodeId]:
      'Knoten, der derzeit als Cluster-Master fungiert — koordiniert die Ausführung geplanter Jobs.',
  },
}
